import styled from 'styled-components';

import { Input } from '@thinkific/toga-react';

const wrapped = styled(Input)`
  input {
    box-sizing: border-box;
  }
`;

export default wrapped;
